import React, { useState } from 'react';
const mockData = {
  zones: [{
    id: 1,
    name: 'Zona Norte'
  }, {
    id: 2,
    name: 'Zona Sur'
  }],
  localities: {
    1: [{
      id: 1,
      name: 'Lima Norte'
    }, {
      id: 2,
      name: 'Callao Norte'
    }],
    2: [{
      id: 3,
      name: 'Lima Sur'
    }, {
      id: 4,
      name: 'Callao Sur'
    }]
  },
  territories: {
    1: [{
      id: 1,
      name: 'Territorio A'
    }],
    2: [{
      id: 2,
      name: 'Territorio B'
    }],
    3: [{
      id: 3,
      name: 'Territorio C'
    }],
    4: [{
      id: 4,
      name: 'Territorio D'
    }]
  }
};
export const ContractorsForm = () => {
  const [selectedZone, setSelectedZone] = useState('');
  const [selectedLocality, setSelectedLocality] = useState('');
  const handleZoneChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedZone(e.target.value);
    setSelectedLocality('');
  };
  return <form className="grid grid-cols-2 gap-6" data-id="element-220">
      <div data-id="element-221">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-222">
          Nombre
        </label>
        <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ingrese nombre completo" data-id="element-223" />
      </div>
      <div data-id="element-224">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-225">
          Identificación
        </label>
        <input type="text" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ingrese número de identificación" data-id="element-226" />
      </div>
      <div data-id="element-227">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-228">
          Correo
        </label>
        <input type="email" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="correo@ejemplo.com" data-id="element-229" />
      </div>
      <div data-id="element-230">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-231">
          Teléfono
        </label>
        <input type="tel" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" placeholder="Ingrese número telefónico" data-id="element-232" />
      </div>
      <div data-id="element-233">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-234">
          Zona
        </label>
        <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={selectedZone} onChange={handleZoneChange} data-id="element-235">
          <option value="" data-id="element-236">Seleccione una zona</option>
          {mockData.zones.map(zone => <option key={zone.id} value={zone.id} data-id="element-237">
              {zone.name}
            </option>)}
        </select>
      </div>
      <div data-id="element-238">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-239">
          Localidad
        </label>
        <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" value={selectedLocality} onChange={e => setSelectedLocality(e.target.value)} disabled={!selectedZone} data-id="element-240">
          <option value="" data-id="element-241">Seleccione una localidad</option>
          {selectedZone && mockData.localities[selectedZone]?.map(locality => <option key={locality.id} value={locality.id} data-id="element-242">
                {locality.name}
              </option>)}
        </select>
      </div>
      <div data-id="element-243">
        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-244">
          Territorio
        </label>
        <select className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500" disabled={!selectedLocality} data-id="element-245">
          <option value="" data-id="element-246">Seleccione un territorio</option>
          {selectedLocality && mockData.territories[selectedLocality]?.map(territory => <option key={territory.id} value={territory.id} data-id="element-247">
                {territory.name}
              </option>)}
        </select>
      </div>
      <div className="col-span-2 flex justify-end" data-id="element-248">
        <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700" data-id="element-249">
          Guardar
        </button>
      </div>
    </form>;
};